import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../hooks/useNotification';
import './SettingsForm.css';

const SettingsForm: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { NotificationContainer } = useNotification();
  const [language, setLanguage] = useState(i18n.language || 'en');

  const handleLanguageChange = async (newLanguage: string) => {
    setLanguage(newLanguage);
    await i18n.changeLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  return (
    <div className="settings-form">
      <NotificationContainer />
      <header className="settings-header">
        <h2>{t('settingsForm.title')}</h2>
      </header>

      <section className="settings-section">
        <h3>{t('settingsForm.systemConfig')}</h3>
        <div className="form-grid">
          <div className="form-field">
            <label>{t('settingsForm.language')}</label>
            <select
              value={language}
              onChange={(e) => handleLanguageChange(e.target.value)}
            >
              <option value="en">{t('languages.en')}</option>
              <option value="it">{t('languages.it')}</option>
            </select>
          </div>
        </div>
      </section>

      <div className="settings-actions">
        <button onClick={() => navigate('/')} className="btn-back">
          <span className="material-icons">arrow_back</span> {t('common.back')}
        </button>
      </div>

      <div className="settings-info">
        <p><strong>{t('app.version')}:</strong> 1.0.0</p>
        <p><strong>{t('app.buildDate')}:</strong> {new Date().toLocaleDateString()}</p>
      </div>
    </div>
  );
};

export default SettingsForm;
